import $ from 'jquery';

export default  {
    isPartOf(selector) {
        const container = $(selector);
        return this.is(container[0]) || this.isDescendantOf(container);
    },
    isDescendantOf(selector) {
        const container = $(selector);
        return container.find(this).length > 0;
    }
};